import type { Risk } from '../enums'

export type Addon = {
  riskId: number
  riskVariantId?: number | null
  insuranceVariantId?: number | null
}

export type InsurerProductAddition = {
  id: number
  name: string
  description?: string
  displayOrder: number
  riskId: number
}

export type InsurerProductPartAvailable = {
  id: number
  name: string
  description?: string
  price: number
  priceFrequency: number
  insurerProductId?: number
  insurerInternalId: string
  limit?: string
  days?: number
}

export type AvailableAddons = {
  group: InsurerProductAddition
  items: InsurerProductPartAvailable[]
}

export const ToAddon = (value: string, risk: Risk): Addon => {
  const riskVariantId = parseInt(value)

  return {
    riskId: parseInt(risk.toString()),
    riskVariantId: riskVariantId == 0 || !!riskVariantId ? riskVariantId : undefined,
  }
}
